import React from 'react';

interface UnLoggedLayoutProps {
  children: React.ReactNode;
  meitLogoImgSrc: string;
  meitBoxesImgSrc: string;
  roleTranslated?: string;
  bgClassName?: string;
  userType?: string;
}

function UnLoggedLayout({
  children,
  meitBoxesImgSrc,
  meitLogoImgSrc,
  userType = 'client',
  roleTranslated = '',
  bgClassName = '',
}: UnLoggedLayoutProps) {
  return (
    <main
      className={`relative min-h-screen w-full bg-login-allies-companies flex ${bgClassName}`}
    >
      {/* form */}
      <section className="relative z-20 w-full lg:w-1/2 mx-auto flex flex-col items-center justify-center my-5 ">
        {/* meit logo */}
        <div className="flex justify-center relative ">
          <img className="w-44 sm:" src={meitLogoImgSrc} alt="logo" />
          {userType !== 'client' ? (
            <span
              className={` absolute text-xs sm:text-base bottom-0 uppercase mt-auto pb-[0.8rem] ${
                userType === 'admin'
                  ? 'text-neutral-warm-500 -right-24 md:-right-32'
                  : 'text-purple-100 -right-20'
              }`}
            >
              {roleTranslated}
            </span>
          ) : null}
        </div>
        {/* card */}
        <div className="mx-10 max-w-lg bg-system-100 flex flex-col rounded-lg p-5 sm:p-10 space-y-6">
          {children}
        </div>
        <div className="w-full text-center mt-5">
          <span className="text-text-white ">
            © Meit!, 2022 | Powered by Avila Tek
          </span>
        </div>
      </section>
      {/* bg boxes */}
      <div className="absolute w-full h-[70vh] bottom-0 overflow-hidden flex">
        <img
          className="relative w-full h-full object-cover object-top mt-auto"
          src={meitBoxesImgSrc}
          alt="meit-bg"
        />
      </div>
    </main>
  );
}

export default UnLoggedLayout;
